<template>
  <div class="flag_manage" >
    <el-divider content-position="left">目标管理</el-divider>
    <div class="changeHeight m-tabs-content">
      <el-row type="flex" >
        <el-col :span="2"   class="tr m-label text_right">选择日期</el-col>
        <el-col :span="4">
          <div>
            <el-date-picker
              v-model="value1"
              type="date"
              size="mini"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              @change="pickerDataChange"
              placeholder="选择日期">
            </el-date-picker>
          </div>
        </el-col>
        <el-col :span="2"  :offset="2" class="tr m-label text_right">选择角色</el-col>
        <el-col :span="4" >
          <el-select
            :filterable="true"
            multiple
            collapse-tags
            v-model="highSearch.roles"
            placeholder="请选择角色"
            size="mini"  clearable>
            <el-option
              v-for="(item, index) in rolesNames"
              :key="index"
              :label="item.role_name"
              :value="item.id" >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="2"  :offset="2" class="tr m-label text_right">选择人员</el-col>
        <el-col :span="4" >
          <el-select
            :filterable="true"
            multiple
            collapse-tags
            v-model="highSearch.uid"
            placeholder="请选择人员"
            size="mini"  clearable>
            <el-option
              v-for="(item, index) in ConversionPeople"
              :key="index"
              :label="item.username"
              :value="item.id" >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6" class="tr">
          <el-button type="primary" size="mini" @click="handleSearch">查询</el-button>
          <el-button type="danger" size="mini" @click="handleCloseSearch">清除</el-button>
        </el-col>
      </el-row>
      <el-row type="flex">
        <el-col :span="6">
          <router-link to="flag_chart" style="color: rgb(87, 135, 255);">数据看板</router-link>
        </el-col>
      </el-row>
    </div>
    <el-table :data="pageData" @sort-change="sortChange" size="medium" style="width: 100%">
      <el-table-column fixed label="区域" prop="department"></el-table-column>
      <el-table-column
        v-for="(item, index) in col"
        :key="index"
        :prop="item.prop"
        :label="item.label"
        :fixed="index < 1"
        sortable="custom"
        :min-width="tableColumnMin(item.prop)">
<!--        :width="tableColumn(item.prop)"-->
        <template slot-scope="scope">
          <div style="cursor: pointer;width: 100%" v-if="item.prop === 'username'" :content="scope.row[item.prop] + ''">
            <span @click="handleFlagDetail(scope.row.uid)" class="dot" style="display: inline-block;color: #5787FF">{{scope.row.username}}</span>
          </div>
          <div style="width: 100%" v-else-if="item.prop === 'cloud_status'" :content="scope.row[item.prop] + ''">
            <span
              class="dot"
              :style="scope.row.cloud_count < scope.row.target_cloud  ? 'color: red' : '' ||
              scope.row.cloud_count > scope.row.target_cloud ? 'color: #2EB9C3' : '' ||
              scope.row.cloud_count > scope.row.target_cloud && scope.row.meal_count > scope.row.target_combo ? 'color: #2EB9C3' : ''"
              style="display: inline-block;">
              {{scope.row.cloud_status}}
            </span>
          </div>
          <div style="width: 100%" v-else-if="item.prop === 'combo_status'" :content="scope.row[item.prop] + ''">
            <span
              class="dot"
              :style="scope.row.meal_count < scope.row.target_combo  ? 'color: red' : '' ||
               scope.row.meal_count > scope.row.target_combo ? 'color: #2EB9C3' : '' ||
               scope.row.meal_count > scope.row.target_combo && scope.row.cloud_count > scope.row.target_cloud  ? 'color: #2EB9C3' : ''"
              style="display: inline-block;">
              {{scope.row.combo_status}}
            </span>
          </div>
<!--          <div style="cursor: pointer;width: 100%" v-else-if="item.prop === 'status'"  :content="scope.row[item.prop] + ''">-->
<!--            <span  class="dot" style="display: inline-block;">-->
<!--              {{scope.row.target_cloud >= scope.row.cloud_count && scope.row.target_combo >= scope.row.meal_count ? '完成' : '未完成'}}-->
<!--            </span>-->
<!--          </div>-->
          <div v-else :content="scope.row[item.prop]">
            <span class="count_style" style="display: inherit">{{scope.row[item.prop]}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="" v-if="false">
<!--        <template slot-scope="scope">-->
<!--          <el-tooltip class="item"  effect="dark" content="沟通记录/线索历史" placement="top">-->
<!--            <el-button type="success" size="mini" icon="el-icon-time" @click="handleContactOpen(scope.$index, scope.row)" circle></el-button>-->
<!--          </el-tooltip>-->
<!--        </template>-->
      </el-table-column>
    </el-table>
<!--    <el-pagination-->
<!--      background-->
<!--      class="tr mt-10"-->
<!--      layout="sizes, total, prev, pager, next, jumper"-->
<!--      :hide-on-single-page="false"-->
<!--      :current-page="search ? pageOption.currentPage2 : pageOption.currentPage"-->
<!--      :page-sizes="[10, 25, 50]"-->
<!--      :page-size="pageOption.pageSize"-->
<!--      :total="pageOption.total"-->
<!--      @size-change="handleSizeChange"-->
<!--      @current-change="handleCurrentChange">-->
<!--    </el-pagination>-->
    <el-drawer
      title="本月目标情况"
      :visible.sync="ContactDrawer"
      direction="rtl"
      size="80%">
<!--      :before-close="handleAddDrawerBeforeClose"-->
      <div class="m-tabs-content">
        <el-row>
          <el-col :span="24">
            <div style="display: flex">
              <!-- <el-tooltip :content="'姓名：' + header.user_name + '，已达标：' + header.ok_count + '，未达标：' + header.not_count + '，总共达标：' + header.all_count + '，云上退款数：' + header.cloud_refund_count + '，套餐退款数：' + header.meal_refund_count + '，单品退款数：' + header.item_refund_count + '，完成率：' + header.reaching" placement="top"> -->
                <div class="count_style">
                  <span class="count" style="margin-right: .2rem">姓名：<span style="color: rgb(87, 135, 255);;">{{header.user_name}}</span></span>
                  <span class="count" style="margin-right: .2rem">云上总目标：{{header.total_target_cloud}}</span>
                  <span class="count" style="margin-right: .2rem">云上实际完成：{{header.actul_cloud_count}}</span>
                  <span class="count" style="margin-right: .2rem">云上完成率：{{header.cloud_rate + '%'}}</span>
                  <span class="count" style="margin-right: .2rem">套餐总目标：{{header.total_target_combo}}</span>
                  <span class="count" style="margin-right: .2rem">套餐实际完成：{{header.actul_combo_count}}</span>
                  <span class="count" style="margin-right: .2rem">套餐完成率：{{header.combo_rate + '%'}}</span>
                  <span class="count" style="margin-right: .2rem">单品实际完成：{{header.actul_item_count}}</span>
                  <br>
                  <span class="count" style="margin-right: .2rem">超额（天）：{{header.overed}}</span>
                  <span class="count" style="margin-right: .2rem">达标（天）：{{header.ok_count}}</span>
                  <span class="count" style="margin-right: .2rem">合格（天）：{{header.passed}}</span>
                  <span class="count" style="margin-right: .2rem">未达标（天）：{{header.not_count}}</span>
                  <!-- <span class="count" style="margin-right: .2rem">已达标：{{header.ok_count}}</span> -->
                  <!-- <span class="count" style="margin-right: .2rem">已达标：{{header.ok_count}}</span> -->
                  <!-- <span class="count" style="margin-right: .2rem">已达标：{{header.ok_count}}</span> -->
                  <!-- <span class="count" style="margin-right: .2rem;">未达标：<span style="color: red;">{{header.not_count}}</span></span> -->
                  <!-- <span class="count" style="margin-right: .2rem">总共达标：<span style="color: rgb(87, 135, 255);">{{header.all_count}}</span></span> -->
                  <span class="count" style="margin-right: .2rem">云上退款数：{{header.cloud_refund_count}}</span>
                  <span class="count" style="margin-right: .2rem">套餐退款数：{{header.meal_refund_count}}</span>
                  <span class="count" style="margin-right: .2rem">单品退款数：{{header.item_refund_count}}</span>
                  <!-- <span class="count">完成率：{{header.reaching + '%'}}</span> -->
                </div>
              <!-- </el-tooltip> -->
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div style="display: flex">
              <!-- <el-tooltip :content="'姓名：' + header.user_name + '，已达标：' + header.ok_count + '，未达标：' + header.not_count + '，总共达标：' + header.all_count + '，云上退款数：' + header.cloud_refund_count + '，套餐退款数：' + header.meal_refund_count + '，单品退款数：' + header.item_refund_count + '，完成率：' + header.reaching" placement="top"> -->
              <div class="count_style">
                <span class="count" style="margin-right: .2rem">云上月分配目标：{{consult.consult_cloud}}</span>
                <span class="count" style="margin-right: .2rem">套餐月分配目标：{{consult.consult_combo}}</span>
                <span class="count" style="margin-right: .2rem">单品月分配目标：{{consult.consult_item}}</span>
                <span class="count" style="margin-right: .2rem">本月领取：{{dayChange.person_get}}</span>
                <span class="count" style="margin-right: .2rem">本月分配：{{dayChange.allot_get}}</span>
                <span class="count" style="margin-right: .2rem">本月总放弃：{{dayChange.give_up}}</span>
                <span class="count" style="margin-right: .2rem">本月领取本月放弃：{{dayChange.current_day_give_up}}</span>
                <span class="count" style="margin-right: .2rem">本月领取本月沟通：{{dayChange.communicat}}</span>
                <span class="count" style="margin-right: .2rem">本月领取沟通率：{{dayChange.execute_rate + '%'}}</span>
              </div>
              <!-- </el-tooltip> -->
            </div>
          </el-col>
        </el-row>
        <el-row type="flex">
          <el-col :span="4">
            <div class="level count_style">
              <span class="count" style="color: #5787FF">达标标准：</span>
              <i class="el-icon-question" @click="dialogVisible3 = true"></i>
            </div>
          </el-col>
          <el-col :span="20" class="tr">
            <el-date-picker
              v-model="selectMonth"
              type="month"
              size="mini"
              style="width: 30% !important;"
              format="yyyy 年 MM 月"
              value-format="yyyy-MM"
              placeholder="选择月份"
              @change="handleSelectMonth">
            </el-date-picker>
          </el-col>
        </el-row>
        <el-table :data="pageDataMonth" max-height="700"   @sort-change="sortChange"  size="medium" style="width: 100%">
          <el-table-column fixed label="日期"  width="200" prop="time">
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.time" placement="top">
<!--                class="count_style" -->
                <span  style="display: inherit">{{scope.row.time}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            v-for="(item, index) in colMonth"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            sortable="custom"
            :min-width="tableColumnMonthMin(item.prop)">
<!--            :width="tableColumn(item.prop)"-->
            <template slot-scope="scope">
              <el-tooltip v-if="item.prop === 'cloud_refund'" :content="scope.row[item.prop] + ''" placement="top">
                <span class="count_style" style="display: inherit">{{scope.row[item.prop]}}</span>
              </el-tooltip>
              <el-tooltip v-else-if="item.prop === 'meal_refund'" :content="scope.row[item.prop] + ''" placement="top">
                <span class="count_style" style="display: inherit">{{scope.row[item.prop]}}</span>
              </el-tooltip>
              <el-tooltip v-else-if="item.prop === 'item_refund'" :content="scope.row[item.prop] + ''" placement="top">
                <span class="count_style" style="display: inherit">{{scope.row[item.prop]}}</span>
              </el-tooltip>
              <el-tooltip v-else-if="item.prop === 'cloud_refund_time'" :content="scope.row[item.prop] + ''" placement="top">
                <span class="count_style" style="display: inherit">{{scope.row[item.prop]}}</span>
              </el-tooltip>
              <el-tooltip v-else-if="item.prop === 'meal_refund_time'" :content="scope.row[item.prop] + ''" placement="top">
                <span class="count_style" style="display: inherit">{{scope.row[item.prop]}}</span>
              </el-tooltip>
              <el-tooltip v-else-if="item.prop === 'item_refund_time'" :content="scope.row[item.prop] + ''" placement="top">
                <span class="count_style" style="display: inherit">{{scope.row[item.prop]}}</span>
              </el-tooltip>
              <el-tooltip v-else :content="scope.row[item.prop] + ''" placement="top">
                <span class="count_style" style="display: inherit">{{scope.row[item.prop]}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
<!--          <el-table-column label="云上退单时间"  width="130" prop="cloud_refund_time">-->
<!--            <template slot-scope="scope">-->
<!--              <el-tooltip :content="scope.row.cloud_refund_time" placement="top">-->
<!--                <span class="count_style" style="display: inherit">{{scope.row.cloud_refund_time}}</span>-->
<!--              </el-tooltip>-->
<!--            </template>-->
<!--          </el-table-column>-->
<!--          <el-table-column label="套餐退单时间"  width="130" prop="meal_refund_time">-->
<!--            <template slot-scope="scope">-->
<!--              <el-tooltip :content="scope.row.meal_refund_time" placement="top">-->
<!--                <span class="count_style" style="display: inherit">{{scope.row.meal_refund_time}}</span>-->
<!--              </el-tooltip>-->
<!--            </template>-->
<!--          </el-table-column>-->
<!--          <el-table-column label="单品退单时间"  width="130" prop="item_refund_time">-->
<!--            <template slot-scope="scope">-->
<!--              <el-tooltip :content="scope.row.item_refund_time" placement="top">-->
<!--                <span class="count_style" style="display: inherit">{{scope.row.item_refund_time}}</span>-->
<!--              </el-tooltip>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column fixed="right" label="" v-if="false">
            <!--        <template slot-scope="scope">-->
            <!--          <el-tooltip class="item"  effect="dark" content="沟通记录/线索历史" placement="top">-->
            <!--            <el-button type="success" size="mini" icon="el-icon-time" @click="handleContactOpen(scope.$index, scope.row)" circle></el-button>-->
            <!--          </el-tooltip>-->
            <!--        </template>-->
          </el-table-column>
        </el-table>
<!--        <el-pagination-->
<!--          background-->
<!--          class="tr mt-10"-->
<!--          layout="sizes, total, prev, pager, next, jumper"-->
<!--          :hide-on-single-page="false"-->
<!--          :current-page="search ? pageOptionMonth.currentPage2 : pageOptionMonth.currentPage"-->
<!--          :page-sizes="[10, 25, 50]"-->
<!--          :page-size="pageOptionMonth.pageSize"-->
<!--          :total="pageOptionMonth.total"-->
<!--          @size-change="handleSizeChangeMonth"-->
<!--          @current-change="handleCurrentChangeMonth">-->
<!--        </el-pagination>-->
      </div>
    </el-drawer>
    <el-dialog
      :visible.sync="dialogVisible3"
      class="el_dialogs"
      width="45%">
      <div class="box_title">
        <span style="font-size:20px;">&nbsp;&nbsp;达标标准：</span>
      </div>
      <div class="dialog_box dialog_img" v-if="pic_url">
        <img width="100%" height="100%" :src="pic_url"/>
      </div>
      <span slot="footer" class="dialog-footer"></span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'flag_manage',
  data () {
    return {

      imgPath: this.$store.state.imgPath,
      percentNum: '',
      count: '',
      consult: [],
      cluesNum: '',
      cluesIndex: 0,
      FlagManage: [],
      FlagManageMonth: [],
      OperationRecord: [],
      ContactDrawer: false,
      search: '',
      value1: '',
      roles: [],
      options: [],
      ConversionPeople: [],
      rolesNames: [],
      activities: [],
      highSearch: {
        dateTime: '',
        uid: []
      },
      optionProps: {
        value: 'id',
        label: 'Provincial',
        children: 'son'
      },
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        currentPage2: 1, // 当前页数
        pageSize: 10 // 每页显示条数
      },
      pageOptionMonth: {
        total: 0,
        currentPage: 1, // 当前页数
        currentPage2: 1, // 当前页数
        pageSize: 10 // 每页显示条数
      },
      dialogVisible3: false,
      col: [
        {
          label: '姓名',
          prop: 'username',
          display: false
        },
        {
          label: '云上是否完成',
          prop: 'cloud_status',
          display: false
        },
        {
          label: '套餐是否完成',
          prop: 'combo_status',
          display: false
        },
        {
          label: '云上目标',
          prop: 'target_cloud',
          display: false
        },
        {
          label: '套餐目标',
          prop: 'target_combo',
          display: false
        },
        {
          label: '今日分配线索',
          prop: 'today_allot',
          display: false
        },
        {
          label: '今日沟通线索',
          prop: 'today_communicat',
          display: false
        },
        {
          label: '云上完成',
          prop: 'cloud_count',
          display: false
        },
        {
          label: '套餐完成',
          prop: 'meal_count',
          display: false
        },
        {
          label: '单品完成',
          prop: 'item_count',
          display: false
        },
        {
          label: '云上收入',
          prop: 'cloud_royalty',
          display: false
        },
        {
          label: '套餐收入',
          prop: 'combo_royalty',
          display: false
        },
        {
          label: '单品收入',
          prop: 'item_royalty',
          display: false
        },
        {
          label: '总收入',
          prop: 'all_royalty',
          display: false
        }
      ],
      colMonth: [
        {
          label: '云上目标',
          prop: 'target_cloud',
          display: false
        },
        {
          label: '套餐目标',
          prop: 'target_combo',
          display: false
        },
        {
          label: '今日分配线索',
          prop: 'today_allot',
          display: false
        },
        {
          label: '今日沟通线索',
          prop: 'today_communicat',
          display: false
        },
        {
          label: '云上完成',
          prop: 'cloud_count',
          display: false
        },
        {
          label: '套餐完成',
          prop: 'combo_count',
          display: false
        },
        {
          label: '单品',
          prop: 'item_count',
          display: false
        },
        {
          label: '是否达标',
          prop: 'complete',
          display: false
        },
        {
          label: '云上退单',
          prop: 'cloud_refund',
          display: false
        },
        {
          label: '套餐退单',
          prop: 'meal_refund',
          display: false
        },
        {
          label: '单品退单',
          prop: 'item_refund',
          display: false
        },
        {
          label: '云上退单金额',
          prop: 'cloud_refund_money',
          display: false
        },
        {
          label: '套餐退单金额',
          prop: 'meal_refund_money',
          display: false
        },
        {
          label: '单品退单金额',
          prop: 'item_refund_money',
          display: false
        }
      ],
      activeName: 'first',
      combo: [],
      items: [],
      tabData: [],
      couldMealItem: {},
      selectMonth: '',
      selectMonthId: null,
      header: {
        user_name: '',
        ok_count: '',
        not_count: '',
        all_count: '',
        any_refund_money: '',
        reaching: '',
        cloud_rate: ''
      },
      dayChange: {},
      pic_url: ''
    }
  },
  computed: {
    pageData: function () {
      return this.FlagManage
      // let currentPage = this.search ? this.pageOption.currentPage2 : this.pageOption.currentPage
      // return this.FlagManage.filter(data => !this.search ||
      //   (data.custom_name && data.custom_name.toLowerCase().includes(this.search.toLowerCase())) ||
      //   (data.custom_phone && data.custom_phone.toLowerCase().includes(this.search.toLowerCase()))).slice(this.pageOption.pageSize * (currentPage - 1),
      //   this.pageOption.pageSize * currentPage)
    },
    pageDataMonth: {
      get: function () {
        return this.FlagManageMonth
        // return this.FlagManageMonth.slice(this.pageOptionMonth.pageSize * (this.pageOptionMonth.currentPage - 1), this.pageOptionMonth.pageSize * this.pageOptionMonth.currentPage)
      }
    },
    collapse () {
      return this.$store.state.collapse
    }
  },
  watch: {
    search: function () {
      this.pageOption.total = this.search ? this.searchTotal() : this.tabData.length
      this.pageOption.currentPage2 = 1
    }
  },
  methods: {
    handleSelectMonth (val) {
      this.selectMonth = val
      this.handleFlagDetailMethods(this.selectMonthId)
    },
    handleFlagDetail (id) {
      this.ContactDrawer = true
      this.selectMonthId = id
      this.handleFlagDetailMethods(id)
    },
    handleFlagDetailMethods (id) {
      this.$axios.get('/api/threadstat/user_target/' + id, {
        params: {
          year_month: this.selectMonth
        }
      })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.FlagManageMonth = data.data.list
            this.header = data.data.header
            this.dayChange = data.data.dayChange
            this.consult = data.data.consult
            if (data.data.pic_url) {
              this.pic_url = this.imgPath + data.data.pic_url
            }
          }
        })
    },
    sortChange (column) {
      if (column.order === 'descending') {
        this.handelGetOrders(
          this.highSearch.dateTime,
          this.highSearch.uid,
          this.highSearch.roles,
          column.prop,
          0
        )
      } else if (column.order === 'ascending') {
        this.handelGetOrders(
          this.highSearch.dateTime,
          this.highSearch.uid,
          this.highSearch.roles,
          column.prop,
          1
        )
      } else {
        this.handelGetOrders(
          this.highSearch.dateTime,
          this.highSearch.uid,
          this.highSearch.roles,
          '',
          ''
        )
      }
    },
    tableColumnMin (prop) {
      let width = ''
      if (prop === 'username') {
        width = 120
      }
      // all_royalty: 0
      // cloud_count: 0
      // cloud_royalty: 0
      // combo_royalty: 0
      // department: "静安"
      // item_count: 0
      // item_royalty: 0
      // meal_count: 0
      // target_cloud: 0
      // target_combo: 0
      // uid: 1
      // username: "张六六"
      if (prop === 'all_royalty') {
        width = 140
      }
      if (prop === 'combo_status' || prop === 'cloud_status') {
        width = 160
      }
      if (prop === 'today_allot' || prop === 'today_communicat') {
        width = 160
      }
      let vipData = ['cloud_count', 'item_count', 'meal_count', 'target_cloud', 'target_combo', 'cloud_royalty', 'combo_royalty', 'item_royalty']
      if (vipData.indexOf(prop) !== -1) {
        width = 150
      }
      return width
    },
    tableColumnMonthMin (prop) {
      let width = ''
      let vipData = ['target_combo', 'combo_count', 'cloud_count', 'target_cloud', 'cloud_refund', 'meal_refund', 'item_refund', 'complete']
      if (vipData.indexOf(prop) !== -1) {
        width = 120
      }
      if (prop === 'today_allot' || prop === 'today_communicat') {
        width = 160
      }
      if (prop === 'cloud_refund_money' || prop === 'meal_refund_money' || prop === 'item_refund_money') {
        width = 130
      }
      return width
    },
    provinceCityData () {
      this.$axios.get('/api/thread/cities')
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            for (var a = 0; a < data.data.length; a++) {
              this.options.push(data.data[a])
            }
          }
        })
    },
    handleClick (tab, event) {
      // console.log(tab, event)
    },
    handleAddDrawerBeforeClose (done) {
      this.$confirm('确认关闭?')
        .then(_ => {
          this.clearAddData()
          done()
        })
        .catch(_ => {})
    },
    clearAddData () {
      this.activities = []
      this.OperationRecord = []
      this.selectMonth = ''
    },
    handelGetSerach () {
      this.$axios.get('/api/threadstat/combo_items', {})
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.combo = data.data.combo
            this.items = data.data.items
          }
        })
    },
    handelGetOrders (dateTime, Uid, Roles, Field, orderBy) {
      this.$axios.post('/api/threadstat/royalty_list', {
        date_time: dateTime,
        uids: Uid,
        roles: Roles,
        field: Field,
        order_by: orderBy
      })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.FlagManage = data.data.list
            this.ConversionPeople = data.data.user
            this.rolesNames = data.data.roles
            this.pageOption.total = this.FlagManage.length
          }
        })
    },
    handleSizeChange (val) {
      this.pageOption.pageSize = val
    },
    handleCurrentChange (val) {
      this.pageOption.currentPage = val
    },
    handleSizeChangeMonth (val) {
      this.pageOptionMonth.pageSize = val
    },
    handleCurrentChangeMonth (val) {
      this.pageOptionMonth.currentPage = val
    },
    searchTotal () {
      return this.FlagManage.filter(data => !this.search || (data.custom_name && data.custom_name.toLowerCase().includes(this.search.toLowerCase())) || (data.custom_phone && data.custom_phone.toLowerCase().includes(this.search.toLowerCase()))).length
    },
    groupInput (val) {
      this.highSearch.group_chat_id = val
    },
    pickerDataChange (val) {
      // console.log(val)
      if (!val) {
        this.highSearch.dateTime = ''
      } else {
        this.highSearch.dateTime = val
      }
    },
    handleSearch () {
      this.handelGetOrders(
        this.highSearch.dateTime,
        this.highSearch.uid,
        this.highSearch.roles
      )
    },
    handleCloseSearch () {
      this.value1 = ''
      this.highSearch.dateTime = ''
      this.highSearch.uid = []
      this.highSearch.roles = []
      this.handelGetOrders(
        this.value1,
        this.highSearch.uid,
        this.highSearch.roles
      )
    },
    handleChangeHeight (val) {}
  },
  mounted () {
    this.handelGetOrders()
    this.handelGetSerach()
  }
}
</script>

<style scoped lang="stylus">
  @import '~styles/varibles.styl'
  @import '~styles/vertical.styl'
  @import '~styles/icon.styl'
  .el-drawer__wrapper >>> .el-drawer
    overflow-y: auto
  .el-drawer__wrapper >>> .el-drawer__header span {
    color: #5789F4;
    font-size: 0.36rem;
    font-weight: 400;
  }
  .flag_manage
    marginLeft()
    .count_style
      display: inline-block
      overflow: hidden
      text-overflow: ellipsis
      white-space: nowrap
  .tr
    text-align: right
  .m-tabs-content
    overflow-y auto
    padding 0 .4rem
    box-sizing border-box
    .m-label
      line-height: .64rem
    .text_right
      text-align left
    .el-row
      margin-bottom: .4rem
  .flag_manage >>> .el-table__header th
    color: #333333
    background-color: #ECF4FF
  /*.clues_manage >>> .el-table__header thead .is-hidden*/
  /*  color: red*/
  /*  background-color: #ECF4FF*/
  /*  font-size 16px*/
  .mb-10
    margin-bottom: .2rem
    margin-top: 0.4rem
  .mt-10
    margin-top: .2rem
  .level
    display flex
    align-items center
    position relative
    padding-right .32rem
    img
      width .32rem
      height .30rem
    .el-icon-question
      margin-left: .1rem
      color: #409EFF
      position absolute
      top 0
      right 0
      cursor pointer
  .el-select, .el-cascader
    width: 100%
  .count
    padding-left: .2rem
    line-height: .56rem
  .el-position
    position relative
    .dot
      display inline-block
      width 0.1rem
      height 0.1rem
      border-radius 50%
      margin-right 0.1rem
      position absolute
      top 0
      left -.2rem
      bottom 0
      margin auto
  .el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
  .changeHeight
    padding .2rem
    margin-top .4rem
  .el-collapse
    border-bottom 0
    border-top 0
  .el-collapse >>> .el-collapse-item__header
    color: #4C87FC
    font-weight bold
  .el-collapse >>> .el-collapse-item__arrow
    color: #4C87FC
  .el-collapse >>> .el-collapse-item__content
    padding-bottom 0
  .el_dialogs >>> .el-dialog__body
    padding-left 0
    padding-right 0
  .el_dialogs >>> .el-dialog__header
    padding 0

  .block
    height 6rem
    overflow-y auto
    padding-top .2rem
    padding-left .2rem
    box-sizing border-box

    .time_right
      width 100%
      margin-top .4rem
      overflow hidden
      word-break break-all
      white-space normal
  .el-timeline-item__node--large
    width .4rem
    height .4rem
  /*滚动条整体样式*/
  ::-webkit-scrollbar{
    width: .1rem;/*竖向滚动条的宽度*/
    height: 10px;/*横向滚动条的高度*/
  }
  ::-webkit-scrollbar-thumb{/*滚动条里面的小方块*/
    background: #cdcdcd;
    border-radius: 5px;
  }
  ::-webkit-scrollbar-track{/*滚动条轨道的样式*/
    background: #f8f8f8;
    border-radius: 5px;
  }
  .el-date-editor
    width: 100% !important

</style>



// WEBPACK FOOTER //
// src/pages/flag_manage/flag_manage.vue